// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7eb37cf6","455":"73ae10e3"}[chunkId] + ".chunk.js";
};